import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCaretDown} from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import {faSpinner} from '@fortawesome/pro-solid-svg-icons/faSpinner';
import {NavLink} from "react-router-dom";
import {ButtonType} from "./ButtonTypes";
import {ColourMod} from "../../Data/Enums/LayoutEnums";

const ButtonClass = (props: ButtonType) => {
	return `btn interactive ${props.raised ? 'raised' : ''} ${props.size ? props.size : ''} ${props.iconOnly ? 'btn-icon-only' : props.icon ? 'btn-icon' : ''} 
		${props.fullWidth ? 'btn-block' : ''} ${props.center ? 'btn-center' : ''} ${props.squared ? 'btn-squared' : ''} ${props.alignLeft ? 'btn-align-start' : ''} ${props.extraClass ? props.extraClass : ''} ${props.colour ? props.colour : ColourMod.Secondary}`;
}

const ButtonInner = (props: ButtonType) => {
	return (
		<>
			{props.loading && (
				<span className={'loader'}>
					<FontAwesomeIcon icon={faSpinner} />
				</span>
			)}

			{props.iconOnly && (
				<>
					{props.icon && props.icon}
					{props.addon && props.addon}
				</>
			)}

			{!props.iconOnly && props.children && (
				<>{props.children}</>
			)}

			{!props.iconOnly && !props.children && (
				<>
					{props.icon && props.icon}

					{!props.iconOnly && props.actionLink?.title ? (
						<>{props.actionLink?.title}</>
					) : (
						<span className={`${props.loading ? 'invisible' :''}`}>{props.title}</span>
					)}

					{props.addon && props.addon}
				</>
			)}

			{props.showArrow && (
				<FontAwesomeIcon icon={faCaretDown} style={{ marginInlineStart: 'auto', paddingInlineStart: 'var(--xs-unit)' }} />
			)}
		</>
	)
}

const Button = (props: ButtonType) => {
	const btnClass = ButtonClass(props);

	if(props.onClick) {
		return (
			<div
				className={`${btnClass} ${props.loading ? 'loading' : ''} ${props.disabled ? 'disabled' : ''}`}
				title={props.title}
				onClick={(e) => props.onClick ? props.onClick(e) : null}
				style={props.style}
				tabIndex={props.noKeyboardFocus ? -1 : 0}
			>
				<ButtonInner {...props} />
			</div>
		);
	}

	return (
		<NavLink
			className={`${btnClass} ${props.loading ? 'loading' : ''} ${props.disabled ? 'disabled' : ''}`}
			title={props.actionLink?.title ? props.actionLink?.title : props.title}
			to={props.actionLink?.url ?? window.location}
			style={props.style}
			tabIndex={props.noKeyboardFocus ? -1 : 0}
		>
			<ButtonInner {...props} />
		</NavLink>
	)
}

const ButtonSubmit = (props: ButtonType) => {
	const btnClass = ButtonClass(props);

	return (
		<button
			className={`${btnClass} ${props.loading ? 'loading' : ''}`}
			type={'submit'}
			title={props.title}
			disabled={props.disabled}
			style={props.style}
			tabIndex={props.noKeyboardFocus ? -1 : 0}
		>
			<ButtonInner {...props} />
		</button>
	);
};

export default Button;

export { ButtonSubmit }